





































































































































import DsModal from '@/shared/modal/ds-modal.vue';
import { PropType } from 'vue';
import { Account, Channel } from '@/shared/model/scrap-agent.model';
import VueCustomScrollbar from 'vue-custom-scrollbar/src/vue-scrollbar.vue';
import ScrapAgentService from '@/service/scrap-agent.service';
import WebsocketService from '@/service/websocket.service';
import { inject } from '@vue/composition-api';
import { IMAGES } from '@/constants';

export default {
  components: { DsModal, VueCustomScrollbar },
  inject: ['websocketService'],
  props: {
    open: Boolean,
    channelConnect: {
      type: Object as PropType<Channel>,
      required: true,
    },
    highLightAccount: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      scrollSettings: {
        maxScrollbarLength: 100,
        suppressScrollX: true,
        wheelPropagation: true,
      },
      showModal: this.open,
      appInfo: null,
      authState: '',
      size: -1,
      accountIdNew: null,
      isReAuthor: false,
      messageProcessed: false,
      item: {} as Account,
      scrapAgentService: new ScrapAgentService(),
      redirectUrl: window.location.origin + '/api/public/goAuth',
    };
  },
  methods: {
    handleCloseModal() {
      this.$emit('modal:close');
      this.isReAuthor = false;
      // console.log(this.channelConnect.accounts.length, 'accc length');
      // console.log(this.size, 'size');
    },
    handleShowAddAccount() {
      this.$emit('modal:AddAccount');
    },
    getAccountClass(item) {
      const isHighlight = this.highLightAccount && item.accountId === this.highLightAccount;
      const isExpired = item.isTokenAlive === false || item.isAppAlive === false || item.isTokenStatus === false;
      if (isHighlight) {
        return 'account-highlight';
      } else if (isExpired) {
        return 'account-expired';
      } else {
        return 'account-standard';
      }
    },
    isExpiredAccount(item) {
      if (
        this.channelConnect.channelType === 'DAUM' ||
        this.channelConnect.channelType === 'NAVER_MAIL' ||
        this.channelConnect.channelType === 'NAVER' ||
        this.channelConnect.channelType === 'NAVER_BLOG'
      ) {
        return false;
      } else {
        if (item.isTokenAlive === false || (item.isTokenStatus !== undefined && item.isTokenStatus !== 1) || item.isAppAlive === false) {
          return true;
        } else {
          return false;
        }
      }
    },
    handleSubmitAccount(value: Account, item: any) {
      if (
        value.channelType == 'GMAIL' ||
        value.channelType == 'OUTLOOK' ||
        value.channelType == 'DAUM' ||
        value.channelType == 'YAHOO' ||
        value.channelType == 'NAVER'
      ) {
        this.handleCreateChannelMailSuccess(item, value.channelType);
        return;
      }
      this.$emit('modal:SubmitAccount', value, item);
    },
    handleSkipYoutube() {
      this.$emit('skipYoutube');
    },
    truncateAccountName(accountName, fullName) {
      const maxLength = 30;
      if (this.channelConnect.channelType == 'FACEBOOK') {
        if (fullName.length > maxLength) {
          return fullName.substring(0, maxLength) + '...';
        }
        return fullName;
      }
      if (accountName.length > maxLength) {
        return accountName.substring(0, maxLength) + '...';
      }
      return accountName;
    },
    highLightAcc(index: number, id: any) {
      if (this.isReAuthor === true) {
        this.accountIdNew = null;
        return 'scrap-agent.account.update';
      }
      if (this.channelConnect.accounts.length === 1 || this.channelConnect.accounts.length > this.size) {
        this.accountIdNew = null;
        this.accountIdNew = id;
        return 'scrap-agent.account.new';
      } else {
        if (this.accountIdNew === id) {
          return 'scrap-agent.account.new';
        } else {
          this.accountIdNew = null;
          return 'scrap-agent.account.update';
        }
      }
    },
    handleCreateChannelMailSuccess(account: any, channelType: any) {
      const imageUriMap: Record<string, string> = {
        GMAIL: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/gmail.png',
        YAHOO: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/yahoo.png',
        OUTLOOK: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/outlook.png',
        NAVER: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/navermail.png',
        DAUM: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/daummail.png',
      };
      const channelNameMap: Record<string, string> = {
        GMAIL: 'Gmail',
        YAHOO: 'Yahoo',
        OUTLOOK: 'Outlook',
        NAVER: 'Naver',
        DAUM: 'Daum',
      };
      const value: any = {
        channelId: null,
        channelName: channelNameMap[channelType],
        channelDescription: account.channelDescription || '',
        channelImageUri: imageUriMap[channelType],
        channelType: channelType,
        allowAccess: 'true',
        accounts: [
          {
            accountId: account.accountId,
            accountName: account.accountName || '-',
            dataSource: [
              {
                dataSourceTypes: ['INBOX'],
                value: null,
                descriptionEn: 'Inbox',
                dataSourceAccStatus: 1,
              },
            ],
            isScrap: true,
          },
        ],
      };
      console.log(value, 'account mail');
      this.$emit('addItemEmail', value);
    },
    handleUpdateAccount(item: any) {
      this.item = item;
      console.log(item, 'item');
      const oauthGoogle = ['YOUTUBE', 'GOOGLE_DRIVE', 'GMAIL'];
      const oauthMicrosoft = ['ONE_DRIVE', 'OUTLOOK'];
      const updateLogin = ['DAUM', 'NAVER', 'NAVER_BLOG'];
      if (oauthGoogle.includes(this.channelConnect.channelType)) {
        this.handleReAuthorGoogle(item);
      } else if (oauthMicrosoft.includes(this.channelConnect.channelType)) {
        this.handleReAuthorMicrosoft(item);
      } else if (this.channelConnect.channelType === 'X_TWITTER') {
        this.handleReAuthorX(item);
      } else if (this.channelConnect.channelType === 'FACEBOOK') {
        this.handleReAuthorFaceBook(item);
      } else if (this.channelConnect.channelType === 'DROP_BOX') {
        this.handleReAuthorDropBox(item);
      } else if (this.channelConnect.channelType === 'WORDPRESS') {
        this.handleReAuthorWordpress(item);
      } else if (updateLogin.includes(this.channelConnect.channelType)) {
        this.$emit('openUpdateLogin', item);
      }
    },
    handleReAuthorMicrosoft(item: any) {
      const clientId = this.appInfo.clientId;
      this.authState = this.generateWindowId();
      const redirectUrl = window.location.origin + '/api/public/goAuth';
      const loginHint = item.accountName;
      const scope = encodeURIComponent(this.appInfo.scope);
      const authUrl =
        `https://login.microsoftonline.com/common/oauth2/v2.0/authorize` +
        `?response_type=code` +
        `&client_id=${clientId}` +
        `&redirect_uri=${redirectUrl}` +
        `&response_mode=query` +
        `&scope=${scope}` +
        `&login_hint=${loginHint}` +
        `&state=${this.authState}`;
      const popup = window.open(authUrl, 'Microsoft', 'width=600,height=600');
    },
    handleReAuthorGoogle(item: any) {
      const responseType = 'code';
      this.authState = this.generateWindowId();
      const clientId = this.appInfo.clientId;
      const redirectUrl = window.location.origin + '/api/public/goAuth';
      const loginHint = item.accountName;

      const authUrl =
        `https://accounts.google.com/o/oauth2/v2/auth` +
        `?access_type=offline` +
        `&client_id=${clientId}` +
        `&response_type=${responseType}` +
        `&redirect_uri=${redirectUrl}` +
        `&scope=${this.appInfo.scope}` +
        `&state=${this.authState}` +
        `&login_hint=${loginHint}` +
        `&prompt=consent`;

      const popup = window.open(authUrl, 'Google', 'width=600,height=600');
    },
    handleReAuthorX(item: any) {
      const redirectUrl = window.location.origin + '/api/public/goAuth';
      this.authState = this.generateWindowId();
      const clientId = this.appInfo.clientId;
      const code_verifier = 'goover.ai';
      const authUrl =
        `https://x.com/i/oauth2/authorize` +
        `?response_type=code` +
        `&client_id=${clientId}` +
        `&redirect_uri=${redirectUrl}` +
        `&scope=${this.appInfo.scope}` +
        `&state=${this.authState}` +
        `&code_challenge=ycbxnR_xs-RK8mrNhtv0ZymGWdbNfBn34BuP0N3Deik` +
        `&code_challenge_method=S256`;

      const popup = window.open(authUrl, 'TwitterAuth', 'width=600,height=600');
    },
    handleReAuthorFaceBook(item: any) {
      this.authState = this.generateWindowId();

      const authUrl =
        `https://www.facebook.com/v22.0/dialog/oauth` +
        `?response_type=code` +
        `&client_id=${this.appInfo.clientId}` +
        `&redirect_uri=${this.redirectUrl}` +
        `&scope=${encodeURIComponent(this.appInfo.scope)}` +
        `&state=${this.authState}`;
      const popup = window.open(authUrl, 'FaceBook', 'width=600,height=600');
      try {
        const ws = this.websocketService();
        // Subscribe to the token channel only once
        const subscription = ws.subscribeTokenAuth(this.authState, {
          next: authCode => {
            console.log('Received authCode from WebSocket:', authCode);
            this.handleAccountConnect(authCode).then(r => {});
            subscription.unsubscribe();
          },
          error: err => {
            console.error('Error receiving authCode:', err);
          },
        });
      } catch (error) {
        console.error('Error subscribing to authCode channel:', error);
      }
    },
    handleReAuthorDropBox(item: any) {
      this.authState = this.generateWindowId();
      const clientId = this.appInfo.clientId;
      const authUrl =
        `https://www.dropbox.com/oauth2/authorize` +
        `?response_type=code` +
        `&client_id=${clientId}` +
        `&redirect_uri=${this.redirectUrl}` +
        `&token_access_type=offline` +
        `&force_reauthentication=true` +
        `&scope=${this.appInfo.scope}` +
        `&state=${this.authState}`;
      const popup = window.open(authUrl, 'DropBox', 'width=600,height=600');
    },
    handleReAuthorWordpress(item: any) {
      this.authState = this.generateWindowId();
      const clientId = this.appInfo.clientId;
      const scope = this.appInfo.scope;

      const authUrl =
        `https://public-api.wordpress.com/oauth2/authorize` +
        `?client_id=${clientId}` +
        `&redirect_uri=${this.redirectUrl}` +
        `&response_type=code` +
        `&state=${this.authState}`;

      const popup = window.open(authUrl, 'Wordpress', 'width=600,height=600');
    },
    receiveMessage(event: MessageEvent) {
      if (this.messageProcessed) {
        return;
      }
      // Verify that the message payload contains the expected state and authorization_code.
      if (event.data && event.data.authorization_code && event.data.state === this.authState) {
        this.messageProcessed = true;
        const authCode = event.data.authorization_code;
        console.log('Received matching authorization code:', authCode);
        if (this.channelConnect.channelType !== 'FACEBOOK') {
          this.handleAccountConnect(authCode).then(r => {});
        }
      } else {
        this.messageProcessed = false;
        console.warn('Ignoring unexpected message payload:', event.data);
      }
    },

    async handleAccountConnect(authorizationCode: string) {
      const redirectUrl = window.location.origin + '/api/public/goAuth';
      const payload = {
        account_id: this.item.accountId,
        api_key: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
        channel: this.channelConnect.channelType,
        avatar: this.item.avatar,
        client_id: this.appInfo.clientId,
        authorization_code: authorizationCode,
        app_id: this.appInfo.appId,
        client_secret: this.appInfo.clientSecret,
        redirect_uri: redirectUrl,
        scope: this.appInfo.scope,
      };
      try {
        const result = await this.scrapAgentService.reAuthorAccount(payload);
        // const responseBody = result?.data?.body?.body?.body;
        // if (!responseBody?.isSuccess) {
        //   alert('Authorization failed. Please try again.');
        //   return;
        // }
        this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messReAuSuccess')}`, {
          toaster: 'b-toaster-bottom-right',
          title: `${this.$t('scrap-agent.toast.add-account.titleReAuSuccess')}`,
          variant: 'success',
          solid: true,
          autoHideDelay: 5000,
        });
        this.isReAuthor = true;
        this.$emit('ReAuthorizeSuccess', this.item.accountId);
      } catch (error) {
        const detail = error.response?.data?.detail;
        console.error('error: ', detail);
        if (detail) {
          const match = detail.match(/\{"status":(\d+),"message":"(.+?)"}/);
          if (match) {
            const realStatus = parseInt(match[1]);
            const realMessage = match[2];
            this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messReAuFail')}`, {
              toaster: 'b-toaster-bottom-right',
              title: `${this.$t('scrap-agent.toast.add-account.titleReAuFail')}`,
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000,
            });
          }
        }
      }
      this.messageProcessed = false;
    },
    generateWindowId(): string {
      return 'id_' + Math.random().toString(36).substr(2, 9);
    },
    isOauthAccount() {
      const oauthProviders = ['YOUTUBE', 'GOOGLE_DRIVE', 'ONE_DRIVE', 'FACEBOOK', 'X_TWITTER', 'DROP_BOX', 'GMAIL', 'OUTLOOK', 'WORDPRESS'];
      return oauthProviders.includes(this.channelConnect.channelType);
    },
    onImageError(event) {
      event.target.src = IMAGES.USER_DEFAULT;
    },
    async handleDeleteAccount(item: any) {
      try {
        console.log('this.channelConnect.accounts.length', this.channelConnect.accounts.length);
        const response = await this.scrapAgentService.deleteUserAccount(item.accountId);
        if (response) {
          this.$bvToast.toast(`${this.$t('scrap-agent.toast.delete-account.messSuccess')}`, {
            toaster: 'b-toaster-bottom-right',
            title: `${this.$t('scrap-agent.toast.success')}`,
            variant: 'success',
            solid: true,
            autoHideDelay: 5000,
          });
        }
        console.log('this.channelConnect.accounts.length', this.channelConnect.accounts.length);
        this.$emit('deleteSuccess', item.accountId);
      } catch (error) {
        console.error('Error deleting account:', error);
        this.$bvToast.toast(`${this.$t('scrap-agent.toast.delete-account.messFail')}`, {
          toaster: 'b-toaster-bottom-right',
          title: `${this.$t('scrap-agent.toast.error')}`,
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
      }
      this.size = this.channelConnect.accounts.length;
    },
  },
  watch: {
    open(value) {
      console.log(this.channelConnect, 'this.highLightAccount  channelConnect');
      this.showModal = value;
      this.isReAuthor = false;
      if (value) {
        this.size = this.channelConnect.accounts.length || -1;
        window.removeEventListener('message', this.receiveMessage);
        window.addEventListener('message', this.receiveMessage, false);
      } else {
        window.removeEventListener('message', this.receiveMessage);
      }
      const accountSelect = this.$el.querySelector('.account-select');
      if (accountSelect) {
        accountSelect.style.paddingBottom = '0px';
      }
      if (value) {
        this.scrapAgentService
          .getAppInfo(this.channelConnect.channelType)
          .then((result: any) => {
            if (result && result.body && result.body.length > 0) {
              this.appInfo = {
                appId: result.body[0].appId,
                redirectUrl: result.body[0].redirectUrl,
                clientId: result.body[0].clientId,
                scope: result.body[0].scope,
                clientSecret: result.body[0].clientSecret,
              };
            }
          })
          .catch(error => {
            console.error('Failed to fetch app info:', error);
          });
      }
    },
    // channelConnect: {
    //   immediate: true,
    //   deep: true,
    //   handler(newVal) {
    //     if (newVal && newVal.accounts) {
    //       this.accountIds = newVal.accounts.map(account => account.accountId);
    //     } else {
    //       this.accountIds = [];
    //     }
    //     console.log('number acc: ', this.accountIds);
    //   },
    // },
    showModal(value) {
      this.$emit('update:open', value);
    },
    // channelConnect(value) {
    //   this.size = value.accounts.length;
    //   console.log(this.size, 'this.size');
    // },
  },
};
